import * as React from 'react';
import type { Pagination } from 'interfaces/pagination';
import type { TransportRouteListEntry } from 'contracts/transport-routes';
import type { Filters, PaginationControl } from 'hooks/store/use-transport-route-search-params';
import { apiGeneral, handleApiError, queryBuilder } from 'services/api';

type Payload = {
  pagination?: PaginationControl;
  filters?: Filters;
}

type Response = {
  routes: TransportRouteListEntry[];
  pagination: Pagination;
}

export const useFetchTransportRoutes = () => {
  const fetchTransportRoutes = React.useCallback(async (payload: Payload) => {
    try {
      const filters = payload?.filters ?? {};

      Object.entries(filters).forEach(([key, value]) => {
        if (!value || (Array.isArray(value) && !value?.length)) {
          delete (filters as Record<string, unknown>)[key];
        }
      });

      const queryString = queryBuilder({
        ...filters,
        ...payload?.pagination,
      });
      const { data } = await apiGeneral.get<Response>(`/general-route?${queryString}`);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchTransportRoutes,
  };
};